module.exports = __webpack_public_path__ + "img/renshu1.7a572364.png";